/**
 * Dash0 browser RUM bootstrap.
 *
 * Next.js 15 App Router convention — this file runs once on first
 * client render, before any app code, in EVERY page (no per-page
 * opt-in). Captures: page views, navigation timing, fetch / XHR,
 * Core Web Vitals, frontend errors, sessions.
 *
 * The endpoint URL + auth token are inlined at build time via
 * `NEXT_PUBLIC_*` envs that the Dockerfile receives as build-args
 * from cloudbuild (see apps/web/Dockerfile + cloudbuild.{prod,
 * prod.yaml). The token has `Ingesting` scope only — it's safe
 * for the browser bundle because that's the only thing it lets the
 * holder do. See docs/runbooks/dash0-setup.md.
 *
 * Local dev / CI without these envs: the guard below skips init
 * silently. `pnpm dev` works untouched; no console noise, no failed
 * network calls.
 */
import { init } from '@dash0/sdk-web';
import { rumNoiseOptions, rumReleaseOptions } from '@repo/telemetry/browser';

const endpointUrl = process.env.NEXT_PUBLIC_DASH0_ENDPOINT;
const authToken = process.env.NEXT_PUBLIC_DASH0_AUTH_TOKEN;

if (endpointUrl && authToken) {
  init({
    serviceName: 'connect0-web',
    // CON-28 — drop Next.js prefetch aborts / RSC payload fetches (see @repo/telemetry rum-noise).
    ...rumNoiseOptions(),
    // Release identity, so a captured stack trace names the build whose
    // source maps can resolve it. Spreads to nothing when the build-time
    // envs are absent (dev / CI), leaving the attributes unset rather than
    // blank.
    //
    // These two reads MUST stay literal `process.env.NEXT_PUBLIC_*` member
    // expressions right here. Next inlines them at build time only in this
    // shape and only in app source — hoisting them to a local, or moving
    // them into @repo/telemetry (which ships pre-built and is never visited
    // by the inliner), makes them `undefined` in the browser and silently
    // un-stamps every event. See packages/telemetry/src/rum-release.ts.
    ...rumReleaseOptions({
      version: process.env.NEXT_PUBLIC_APP_VERSION,
      tier: process.env.NEXT_PUBLIC_ENV_TIER,
    }),
    endpoint: {
      url: endpointUrl,
      authToken,
    },
  });
}
